import { NgModule, ErrorHandler, SkipSelf, Optional, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorsService } from './services/errors.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ErrorsService,
    }
  ]
})
export class ErrorsModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ErrorsModule,
      providers: [
        {
          provide: ErrorHandler,
          useClass: ErrorsService,
        }
      ]
    };
  }

  constructror(@Optional() @SkipSelf() parentModule: ErrorsModule) {
    if (parentModule) {
      throw new Error('ErrosModule is already loaded. Import it in the AppModule only');
    }
  }
}
